export default "__VITE_ASSET__DoHX3Ury__"